import { SharedState } from '$utils/sharedState.svelte';
import { type ErrorHandler, ErrorType } from '$types/error';
import * as Sentry from '@sentry/browser';
import { PUBLIC_ENABLE_CLIENT_LOGGING, PUBLIC_ERROR_HANDLING_ENABLED } from '$env/static/public';
import { log } from '$utils/__log';
import { UUID } from '$utils/uuid';

class StateError extends SharedState<ErrorHandler> {
  set(value: ErrorHandler | null): void {
    if (value) {
      value.errorId = UUID();

      if (value.type !== ErrorType.SILENT) {
        if (value.type !== ErrorType.TOAST) {
          if (value.rawError) {
            value.eventId = Sentry.captureException(value.rawError);
          } else {
            value.eventId = Sentry.captureMessage(value.message);
          }
        }

        if (PUBLIC_ERROR_HANDLING_ENABLED === 'true') {
          this._current = value;
        }
      } else {
        if (value.rawError?.status === 404) {
          return;
        }
        if (value.rawError) {
          value.eventId = Sentry.captureException(value.rawError);
        } else {
          value.eventId = Sentry.captureMessage(value.message);
        }
      }

      if (PUBLIC_ENABLE_CLIENT_LOGGING === 'true') {
        log('Error captured:', JSON.stringify(value));
      }
    }
  }
}

export const stateError = new StateError(null);
